import Modal from 'react-native-modal';
import {
  StyleSheet, View,
} from 'react-native';
import { useSelector } from 'react-redux';
import Style from '../../constants/Style';
import Colors from '../../constants/Colors';
import isMobile from '../IsMobile';
import SimplePDFViewer from '../SimplePDFViewer';

interface TermsModalProps {
  isVisible: boolean,
  dismiss: () => void,
}

export default function TermsModal({ isVisible, dismiss }: TermsModalProps) {
  const acceptedTerms: boolean = useSelector((state:
    { user: { acceptedTerms } }) => state.user.acceptedTerms);

  return (
    <Modal
      {...{ isVisible }}
      animationIn={isMobile ? 'slideInUp' : 'fadeIn'}
      animationOut={isMobile ? 'slideOutDown' : 'fadeOut'}
      animationInTiming={isMobile ? 300 : 0}
      onBackButtonPress={dismiss}
      style={Style.modal}
    >
      {!acceptedTerms ? <View style={styles.termsContainer}>
        <SimplePDFViewer {...{ dismiss }} />
      </View> : <View style={styles.container} />}
    </Modal>);
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: isMobile ? 'transparent' : Colors.light.hereworksBackground,
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  termsContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  subTitle: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 24,
    color: Colors.light.hereworksBlack400,
    textAlign: 'center',
  },
});
